import { PropsWithChildren } from 'react'

import { useTheme } from 'antd-style'

import { MenuButton } from '@eastcoal/editor/ui/MenuButton'
import { MenuButtonProps } from '@eastcoal/editor/ui/MenuButton/interface'

export const IsolatedButton = (props: PropsWithChildren<MenuButtonProps>) => {
  const theme = useTheme()
  return (
    <MenuButton
      {...props}
      style={{
        height: 'auto',
        flexDirection: 'column',
        paddingBlock: theme.paddingXS
      }}
    />
  )
}
